module.exports = __webpack_public_path__ + "img/notif.06d106cc.svg";